import React, { useEffect, useState } from "react";
import axiosInstance from '../../../axiosInstance';
import { useParams, Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faPenToSquare,
//   faTrashCan,
//   faCircleCheck,
//   faCircleXmark,
// } from "@fortawesome/free-solid-svg-icons";
// import DeleteModalToast from "./delete";
import VerticalPrimeTable from '../../common/DataTable/verticalPrimeTable';
// import Pencil from 'apollo-react-icons/Pencil';
// import Trash from 'apollo-react-icons/Trash';
import StatusCheck from 'apollo-react-icons/StatusCheck';
import CloseCircle from 'apollo-react-icons/CloseCircle';

const FormDetails = ({persona}) => {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [filteredFormData, setFilteredFormData] = useState(null);
  const [t] = useTranslation();
  // const [showSubComponent, setShowSubComponent] = useState(false);
  // const [selectedData, setSelectedData] = useState({});
  // const navigate = useNavigate();
  // const [setShowModal] = useState(false);

  // const handleShowModal = (id, name) => {
  //   setSelectedData({ id, name });
  //   setShowSubComponent(true);
  // };

  // const handleSubComponentEvent = () => {
  //   console.log("Event triggered inside SubComponent!");
  // };

  // const handleConfirm = () => {
  //   setShowModal(false);
  //   setShowSubComponent(false);
  // };

  useEffect(() => {
    const fetchForm = async () => {
      await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/forms/${id}`, { withCredentials: true })
        .then((response) => {
          setForm(response.data);
        })
        .catch((err) => console.log(err));
    };
    fetchForm();
  }, [id]);

  useEffect(() => {
		if (form) {
			const { version, ...filtered } = form;
			filtered.published =
				form.published === 1 ? (
					<StatusCheck style={{ color: "#198754" }} />
				) : (
					<CloseCircle style={{ color: "#ff0000" }} />
				);

			setFilteredFormData({
        name: filtered.name,
        description: filtered.description,
        status: filtered.published === true ? "Published" : "Unpublished",
        createdAt: filtered.createdAt, updatedAt: filtered.updatedAt,
        createdBy: filtered.User?.username,
      });
		}
	}, [form]);

  if (!form) return <p>{t("Loading...")}</p>;
  // const actions = [
	// 	{
	// 		label: "Edit",
	// 		element: (
	// 			<Link to={`/admin/forms/edit/${form.id}`}>
	// 				<Pencil style={{ color: "#198754" }} />
	// 			</Link>
	// 		),
	// 	},
	// 	{
	// 		label: "Delete",
	// 		element: (
	// 			<Link
	// 				onClick={() => {
	// 					handleShowModal(form.id, form.name);
	// 				}}
	// 			>
	// 				{" "}
	// 				<Trash style={{ color: "#ff0000" }} />
	// 			</Link>
	// 		),
	// 	},
	// ];

  return (
    <div className="container mt-4 col-md-8">
			<VerticalPrimeTable
				data={filteredFormData}
				// actions={actions}
			/>

      <table className="table table-striped table-bordered details-table lg-8">
      <thead>
        <tr><th>Subforms</th></tr>
        {form.subforms.map(subform => <tr key={subform.id}><td>{subform.label}</td></tr>)}
      </thead>
      </table>

      {/* {showSubComponent && (
        <DeleteModalToast
          sentData={selectedData}
          onEvent={handleSubComponentEvent}
          onConfirm={() => {
            handleConfirm();
            navigate(-1);
          }}
        />
      )} */}
    </div>
  );
};

export default FormDetails;
